import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { addUser } from '../utils/userStore';
import logo from '../assets/Logo.png';

const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const Register = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    dueDate: '',
    pregnancyWeek: ''
  });

const handleRegister = async (e) => {
  e.preventDefault();

  if (!formData.email || !formData.password) {
    toast.error("Vui lòng điền đầy đủ thông tin!");
    return;
  }

  try {
    const res = await fetch(`${API_BASE}/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: formData.email,
        password: formData.password,
        pregnancy_week: formData.pregnancyWeek
        ? parseInt(formData.pregnancyWeek)
        : null,
        due_date: formData.dueDate || null,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      toast.error(data.detail || "Đăng ký thất bại!");
      return;
    }

    toast.success("Tạo tài khoản thành công!");
    navigate("/login");

  } catch (err) {
    toast.error("Không thể kết nối server!");
  }
};

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-pink-50 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center space-x-2 group">
            <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-pink-600 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
              <img
                src={logo}
                alt="Logo"
                className="w-10 h-10 object-contain"
              />
            </div>
            <span className="text-3xl font-bold bg-gradient-to-r from-pink-500 to-pink-700 bg-clip-text text-transparent">
              AN NHI
            </span>
          </Link>
        </div>

        <Card className="border-pink-100 shadow-2xl">
          <CardHeader>
            <CardTitle className="text-2xl text-center text-gray-800">
              Tạo tài khoản
            </CardTitle>
            <p className="text-center text-gray-600 mt-2">
              Bắt đầu hành trình thai kỳ của bạn
            </p>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleRegister} className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="name" className="text-gray-700">
                    Họ và tên <span className="text-red-500">*</span>
                  </Label>
                  <Input
                    id="name"
                    placeholder="Nguyễn Văn A"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="mt-1 border-pink-200 focus:border-pink-400"
                  />
                </div>

                <div>
                  <Label htmlFor="email" className="text-gray-700">
                    Email <span className="text-red-500">*</span>
                  </Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="example@email.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="mt-1 border-pink-200 focus:border-pink-400"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="password" className="text-gray-700">
                    Mật khẩu <span className="text-red-500">*</span>
                  </Label>
                  <Input
                    id="password"
                    type="password"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    className="mt-1 border-pink-200 focus:border-pink-400"
                  />
                </div>

                <div>
                  <Label htmlFor="confirmPassword" className="text-gray-700">
                    Xác nhận mật khẩu <span className="text-red-500">*</span>
                  </Label>
                  <Input
                    id="confirmPassword"
                    type="password"
                    placeholder="••••••••"
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                    className="mt-1 border-pink-200 focus:border-pink-400"
                  />
                </div>
              </div>

              <div className="bg-pink-50 p-4 rounded-lg border border-pink-200">
                <h3 className="font-semibold text-gray-800 mb-3">Thông tin thai kỳ (Tuỳ chọn)</h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="dueDate" className="text-gray-700">Ngày dự sinh</Label>
                    <Input
                      id="dueDate"
                      type="date"
                      value={formData.dueDate}
                      onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
                      className="mt-1 border-pink-200 focus:border-pink-400 bg-white"
                    />
                  </div>

                  <div>
                    <Label htmlFor="pregnancyWeek" className="text-gray-700">Tuần thai hiện tại</Label>
                    <Input
                      id="pregnancyWeek"
                      type="number"
                      placeholder="VD: 12"
                      min="1"
                      max="40"
                      value={formData.pregnancyWeek}
                      onChange={(e) => setFormData({ ...formData, pregnancyWeek: e.target.value })}
                      className="mt-1 border-pink-200 focus:border-pink-400 bg-white"
                    />
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-2">
                <input type="checkbox" className="w-4 h-4 text-pink-600 mt-1" required />
                <label className="text-sm text-gray-600">
                  Tôi đồng ý với{' '}
                  <a href="#" className="text-pink-600 hover:underline font-medium">
                    Điều khoản sử dụng
                  </a>{' '}
                  và{' '}
                  <a href="#" className="text-pink-600 hover:underline font-medium">
                    Chính sách bảo mật
                  </a>
                </label>
              </div>

              <Button
                type="submit"
                className="w-full bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white py-6 text-lg"
              >
                Đăng ký
              </Button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-gray-600">
                Đã có tài khoản?{' '}
                <Link to="/login" className="text-pink-600 hover:text-pink-700 font-semibold">
                  Đăng nhập ngay
                </Link>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Register;